"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledShareIconBox = exports.Image = exports.StyledCoverBox = exports.StyledIntroBox = exports.StyledAboutBox = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _StyledLayout = require("../../../../../StyledLayout");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var StyledAboutBox = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__StyledAboutBox",
  componentId: "sc-1ylhuc4-0"
})(["position:relative;padding:76px 0 0 0;", ""], function (props) {
  return props.isTabletPortrait && (0, _styledComponents.css)(["padding:0;"]);
});
exports.StyledAboutBox = StyledAboutBox;
var StyledIntroBox = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__StyledIntroBox",
  componentId: "sc-1ylhuc4-1"
})(["position:relative;width:100%;", ""], function (props) {
  return props.isTabletPortrait && (0, _styledComponents.css)(["width:", "px;"], props.width);
});
exports.StyledIntroBox = StyledIntroBox;
var StyledCoverBox = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__StyledCoverBox",
  componentId: "sc-1ylhuc4-2"
})(["position:relative;width:100%;margin-bottom:24px;", ";"], function (props) {
  return props.isTabletPortrait && (0, _styledComponents.css)(["width:", "px;"], props.width);
});
exports.StyledCoverBox = StyledCoverBox;

var Image = _styledComponents["default"].img.withConfig({
  displayName: "Elements__Image",
  componentId: "sc-1ylhuc4-3"
})(["width:100%;height:100%;object-fit:cover;"]);

exports.Image = Image;
var StyledShareIconBox = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__StyledShareIconBox",
  componentId: "sc-1ylhuc4-4"
})(["margin-top:16px;margin-bottom:70px;> div > div > a > div{width:24px;height:24px;}svg{width:24px;height:24px;path{fill:", ";}}"], function (props) {
  return props.theme.portfolioForeground1;
});
exports.StyledShareIconBox = StyledShareIconBox;